import { render, staticRenderFns } from "./UploadLoading.vue?vue&type=template&id=56f2af8f&scoped=true"
import script from "./UploadLoading.vue?vue&type=script&lang=ts"
export * from "./UploadLoading.vue?vue&type=script&lang=ts"
import style0 from "./UploadLoading.vue?vue&type=style&index=0&id=56f2af8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f2af8f",
  null
  
)

export default component.exports